/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Suggest_LabelInputs */

const en_us2_translation_suggest_label = /** @type {(inputs: Translation_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation`)
};

const pt_br2_translation_suggest_label = /** @type {(inputs: Translation_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução`)
};

const es_419_translation_suggest_label = /** @type {(inputs: Translation_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducción`)
};

const pt_pt2_translation_suggest_label = /** @type {(inputs: Translation_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução`)
};

const fr_fr2_translation_suggest_label = /** @type {(inputs: Translation_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduction`)
};

const de_de2_translation_suggest_label = /** @type {(inputs: Translation_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung`)
};

const it_it2_translation_suggest_label = /** @type {(inputs: Translation_Suggest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduzione`)
};

/**
* | output |
* | --- |
* | "Translation" |
*
* @param {Translation_Suggest_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const translation_suggest_label = /** @type {((inputs?: Translation_Suggest_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Suggest_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_translation_suggest_label(inputs)
	if (locale === "es-419") return es_419_translation_suggest_label(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_suggest_label(inputs)
	if (locale === "fr-FR") return fr_fr2_translation_suggest_label(inputs)
	if (locale === "de-DE") return de_de2_translation_suggest_label(inputs)
	if (locale === "it-IT") return it_it2_translation_suggest_label(inputs)
	return en_us2_translation_suggest_label(inputs)
});
export { translation_suggest_label as "translation.suggest_label" }